import React, { useRef } from "react";
import {
  ContentContainer,
  Text,
  Categories,
  Category,
  CategoryText,
  Row,
  ButtonNext,
  ButtonBack,
  Buttons,
} from "../Steps.styles";

import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  addItemCategoryId,
  addItemState,
  categoriesData,
  resetAddItem,
  selectedMarketplaceItemLoader,
  setCategory,
  setParentCategory,
} from "../../../store/slices/marketplace/marketplaceSlice";
import openToast from "../../../utils/toast";
import AppLoader from "../../AppLoader";

const AddItemStepCategory = ({ onNext, onNextSubcategory }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const activeCategory = useSelector(addItemCategoryId);
  const categories = useSelector(categoriesData);
  const itemLoading = useSelector(selectedMarketplaceItemLoader);
  const addItem = useSelector(addItemState);
  const toastId = useRef(null);

  const handleCategoryClick = (id) => {
    let newSelected;
    if (activeCategory.includes(id)) {
      newSelected = activeCategory.filter((c) => c !== id);
    } else {
      newSelected = [...activeCategory, id];
    }
    dispatch(setCategory(newSelected));
    dispatch(setParentCategory(newSelected));
  };
  const handleNext = () => {
    const anyHasSubcategories = addItem.parentCategoryId.some((id) => {
      const cat = categories?.find((c) => c.id === id);

      return cat?.subcategories?.length > 0;
    });

    if (anyHasSubcategories) {
      onNextSubcategory();
    } else {
      onNext();
    }
  };

  return (
    <>
      <ContentContainer>
        <Row>
          <Text>{t("select-category")}:</Text>
          <Categories>
            {!itemLoading && (
              <>
                {categories?.map((category) => (
                  <Category
                    key={category.id}
                    $active={addItem?.parentCategoryId?.includes(category.id)}
                    onClick={() => {
                      handleCategoryClick(category.id);
                    }}
                  >
                    <CategoryText
                      $active={addItem?.parentCategoryId?.includes(category.id)}
                    >
                      {category.name}
                    </CategoryText>
                  </Category>
                ))}
              </>
            )}
            {itemLoading && <AppLoader size={20} />}
          </Categories>
        </Row>
      </ContentContainer>
      {itemLoading === false && (
        <Buttons>
          <ButtonBack
            onClick={() => {
              navigate("/admin-portal/marketplace");
              dispatch(resetAddItem());
            }}
          >
            {t("back")}
          </ButtonBack>
          <ButtonNext
            onClick={
              !!activeCategory && activeCategory.length
                ? handleNext
                : () => {
                    openToast(
                      toastId,
                      "select-category",
                      "warning",
                      t("please-select-a-category"),
                    );
                  }
            }
          >
            {t("next")}
          </ButtonNext>
        </Buttons>
      )}
    </>
  );
};

export default AddItemStepCategory;
